import React from 'react';
import { Pagination } from '../../../_lib/components/Pagination';
import ResultListSettings from '../../../components/molecules/ResultListSettings/ResultListSettings';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { FACETS } from '../../../components/molecules/ResultListSettings/ResultListSettings.enums';
import { murmurhash } from '../../../lib/js/hash';
import { EventListSearchResults } from '../EventListDetails.types';
import { EventListTeaserItem } from './EventListTeaserItem';
import { TeaserList, TeaserListHeadline, TeaserListOl } from '../../../_lib/components/TeaserList';

type EventListTeaserProps = {
  searchResults: EventListSearchResults;
};

export function EventListTeaser({ searchResults }: EventListTeaserProps) {
  const { t } = useSonTranslation('EventList');
  const { eventStartDate: filter, ...facetsWithoutEventStartDate } = searchResults.facets ?? {};

  return (
    <TeaserList>
      <ResultListSettings
        key={murmurhash(searchResults)}
        sort={searchResults.sort}
        facets={facetsWithoutEventStartDate}
        filter={filter}
        wantedFacets={[FACETS.FQ_PAGE_CATEGORY_TITLES]}
        resetAllFiltersUrl={searchResults.resetAllFiltersUrl}
      />
      {searchResults.events && searchResults.events.length > 0 && (
        <>
          <TeaserListHeadline invisible>{t('headline')}</TeaserListHeadline>
          <TeaserListOl>
            {searchResults.events.map(resultItem => (
              <EventListTeaserItem key={murmurhash(resultItem)} event={resultItem} />
            ))}
          </TeaserListOl>
          <Pagination pageItems={searchResults.pageItems} />
        </>
      )}
    </TeaserList>
  );
}
